import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import { useContext, useEffect } from 'react'
import { inputContext } from '../../../../context/inputsContext'
import { useGetLocations } from '../../../../lib/hooks/api'

export const TownSelect = () => {
  const { values, setValues } = useContext(inputContext)
  const { data: positions } = useGetLocations()

  useEffect(
    () =>
      setValues((current) => {
        if (current.location === null && positions !== undefined)
          return { ...current, location: positions[0] }
        return current
      }),
    [positions, setValues],
  )

  return (
    <FormControl variant="standard" sx={{ m: 1, minWidth: 200 }}>
      <Select
        value={values.location?.name || ''}
        id="simple-select"
        onChange={(event: SelectChangeEvent) =>
          setValues((c) => {
            return {
              ...c,
              location:
                positions?.find((item) => item.name === event.target.value) ||
                null,
            }
          })
        }
      >
        {positions &&
          positions.map((position) => (
            <MenuItem key={position.name} value={position.name}>
              {position.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  )
}

export default TownSelect
